<template>
  <div class="role-edit">
    <el-form
      v-loading="loading"
      :model="roleForm"
      :rules="roleFormRules"
      ref="roleForm"
      status-icon
      label-width="80px"
      style="margin-left: 24px;margin-right: 24px;"
    >
      <el-input type="hidden" v-model="roleForm.id"></el-input>
      <template v-if="isEdit">
        <!-- <el-form-item> -->
        <el-input type="hidden" v-model="roleForm.roleName"></el-input>
        <!-- </el-form-item> -->
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="roleForm.newRoleName"></el-input>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="roleForm.roleName"></el-input>
        </el-form-item>
      </template>
      <el-form-item label="角色描述" prop="roleDesc">
        <el-input
          type="textarea"
          rows="4"
          v-model="roleForm.roleDesc"
        ></el-input>
      </el-form-item>
      <el-form-item class="form-footer">
        <el-button @click="onFormCancle">取消</el-button>
        <el-button type="primary" @click="onFormSave">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addAdminRole, updateAdminRole } from "@/api/adminRole";
export default {
  name: "AdminRoleEdit",
  props: {
    isEdit: {
      type: Boolean,
      required: true
    },
    editForm: {
      type: Object,
      required: false
    }
  },
  data: function() {
    const validateRoleName = (rule, value, callback) => {
      if (!value || value === "" || value.trim() === "") {
        callback(new Error("角色名称不能为空"));
      } else {
        callback();
      }
    };
    const validateNewRoleName = (rule, value, callback) => {
      if (!value || value === "" || value.trim() === "") {
        callback(new Error("角色名称不能为空"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      roleForm: {
        id: null,
        roleName: null,
        newRoleName: null,
        roleDesc: null
      },
      roleFormRules: {
        roleName: [{ validator: validateRoleName, trigger: "blur" }],
        newRoleName: [{ validator: validateNewRoleName, trigger: "blur" }]
      }
    };
  },
  watch: {
    editForm: {
      handler: function(value) {
        if (this.isEdit == true) {
          this.roleForm = value;
          this.roleForm.newRoleName = value.roleName;
        } else {
          this.roleForm = {
            id: null,
            roleName: null,
            newRoleName: null,
            roleDesc: null
          };
        }
      },
      deep: true
    }
  },
  mounted: function() {
    if (this.isEdit == true) {
      this.roleForm = JSON.parse(JSON.stringify(this.editForm));
      this.roleForm.newRoleName = this.editForm.roleName;
    } else {
      this.roleForm = {
        id: null,
        roleName: null,
        newRoleName: null,
        roleDesc: null
      };
    }
  },
  methods: {
    onFormSave: function() {
      let self = this;
      this.$refs["roleForm"].validate(valid => {
        if (valid) {
          self.loading = true;
          if (this.isEdit) {
            updateAdminRole(self.roleForm)
              .then(function() {
                self.$message({
                  message: "更新成功！",
                  type: "success"
                });
                self.$emit("onSaveSuccess");
              })
              .finally(function() {
                self.loading = false;
                self.$refs["roleForm"].resetFields();
                self.$emit("onCancle");
              });
          } else {
            addAdminRole(self.roleForm)
              .then(function() {
                self.$message({
                  message: "新增成功！",
                  type: "success"
                });
                self.$emit("onSaveSuccess");
              })
              .finally(function() {
                self.loading = false;
                self.$refs["roleForm"].resetFields();
                self.$emit("onCancle");
              });
          }
        } else {
          return false;
        }
      });
    },
    onFormCancle: function() {
      this.$emit("onCancle");
    }
  }
};
</script>
